"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFTO781V1MissionData = exports.AFTO781V1MissionDataLandings = void 0;
const base_model_1 = require("../../../base-model");
const afto_781_v1_mission_data_schema_1 = require("./afto_781_v1-mission-data.schema");
class AFTO781V1MissionDataLandings extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_mission_data_schema_1.afto781V1MissionDataLandingsSchema;
    }
}
exports.AFTO781V1MissionDataLandings = AFTO781V1MissionDataLandings;
class AFTO781V1MissionData extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_mission_data_schema_1.afto781V1MissionDataSchema;
    }
}
exports.AFTO781V1MissionData = AFTO781V1MissionData;
